import * as React from 'react';

function SvgBell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M14.232 20.135a1 1 0 01.363 1.367 3 3 0 01-5.19 0 1 1 0 011.666-1.101l.129.196a1 1 0 001.6 0l.065-.099a1 1 0 011.367-.363zM12 .75a7.25 7.25 0 017.246 7.01l.004.24c0 2.86.513 4.997 1.347 6.526.427.782.819 1.222 1.044 1.396l.052.038c.994.662.575 2.18-.568 2.284L21 18.25H3c-1.194 0-1.688-1.495-.794-2.216l.1-.074c.213-.142.635-.587 1.097-1.434.79-1.449 1.292-3.444 1.343-6.08L4.75 8A7.25 7.25 0 0112 .75zm0 2.5a4.75 4.75 0 00-4.745 4.533L7.25 8c0 3.11-.555 5.571-1.507 7.447l-.161.303h12.835l-.014-.026c-.992-1.818-1.594-4.217-1.649-7.262L16.75 8l-.005-.217A4.75 4.75 0 0012 3.25z" />
    </svg>
  );
}

export default SvgBell;
